import notify from "@/utils/notify.js";
import map from "./map.js";

function throwBackendError(error) {
  const text = map[error.reason.response.status];

  notify(text);
}

function throwClientError(error) {
  const code = error.toString().slice(-3);
  const text = map[code];
  console.error(error);

  notify(text);
}

export { throwBackendError, throwClientError };
